<div class="video-container">
    <video controls autoplay></video>

    <img class="watermark" src="assets/img/logo.png">
</div>
